
// export const PlayerBioView = ({ bio }) => {
//   return (
//     <div className="rounded-2xl p-4 sm:p-6 border-jp-line">
//       <h3 className="text-jp-ink font-bold text-base sm:text-lg mb-3 sm:mb-4">PLAYER BIO</h3>
//       <p className="text-jp-muted text-sm sm:text-base leading-relaxed">
//         {bio || 'No bio available.'}
//       </p>
//     </div>
//   );
// };

// export default PlayerBioView;



import React from 'react';

export const PlayerBioView = ({ bio }) => {
  return (
    <div className="">
      <div className="mb-4">
        <h3 className="text-jp-ink font-bold text-lg">PLAYER BIO</h3>
      </div>
      
      <div className="text-left text-jp-muted leading-relaxed rounded-2xl p-6 border border-jp-line bg-jp-section">
        {bio ? (
          <p>{bio}</p>
        ) : (
          <p className="text-jp-muted italic">Bio not available.</p>
        )}
      </div>
    </div>
  );
};

export default PlayerBioView;
